export default __webpack_public_path__ + "static/media/LearningStrategistIcon.8a03578c.svg";